var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 6,
    fill: "#F0E0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4263 65.3573H20.5748C20.0151 65.3573 19.5571 65.8051 19.5571 66.375V69.4282C19.5571 69.988 20.0151 70.4459 20.5748 70.4459H69.4263C69.9861 70.4459 70.444 69.988 70.444 69.4282V66.375C70.444 65.8051 69.9861 65.3573 69.4263 65.3573Z",
    fill: "#4C0A82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8232 29.8075L45.3975 19.6301C45.1431 19.5284 44.8581 19.5284 44.6139 19.6301L20.1882 29.8075C19.8116 29.9704 19.5571 30.3368 19.5571 30.754V33.8073C19.5571 34.367 20.0151 34.825 20.5748 34.825H69.4263C69.9861 34.825 70.444 34.367 70.444 33.8073V30.754C70.444 30.3368 70.1998 29.9704 69.8232 29.8075Z",
    fill: "#4C0A82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.006 60.4315C57.4463 60.4315 56.9883 60.8895 56.9883 61.4492V63.3218H68.102V61.4492C68.102 60.8895 67.6439 60.4315 67.0842 60.4315H66.2191V39.7408H67.0842C67.6439 39.7408 68.102 39.2829 68.102 38.7231V36.8606H56.9883V38.7231C56.9883 39.2829 57.4463 39.7408 58.006 39.7408H58.8609V60.4315H58.006Z",
    fill: "#4C0A82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7057 60.4315C24.146 60.4315 23.688 60.8895 23.688 61.4492V63.3218H34.8017V61.4492C34.8017 60.8895 34.3437 60.4315 33.784 60.4315H32.929V39.7408H33.784C34.3437 39.7408 34.8017 39.2829 34.8017 38.7231V36.8606H23.688V38.7231C23.688 39.2829 24.146 39.7408 24.7057 39.7408H25.5606V60.4315H24.7057Z",
    fill: "#4C0A82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3566 60.4315C40.7969 60.4315 40.3389 60.8895 40.3389 61.4492V63.3218H51.4526V61.4492C51.4526 60.8895 50.9946 60.4315 50.4348 60.4315H49.5799V39.7408H50.4348C50.9946 39.7408 51.4526 39.2829 51.4526 38.7231V36.8606H40.3389V38.7231C40.3389 39.2829 40.7969 39.7408 41.3566 39.7408H42.2115V60.4315H41.3566Z",
    fill: "#4C0A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankFrame);
export default __webpack_public_path__ + "static/media/bank_frame.e1c1df2883a3da32a8f64235a0015403.svg";
export { ForwardRef as ReactComponent };